export const RIDE_TYPES = {
  ECONOMY: 'economy',
  COMFORT: 'comfort',
  PREMIUM: 'premium',
  XL: 'xl'
};

export const BOOKING_STATUSES = {
  PENDING: 'pending',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const DRIVER_STATUSES = {
  OFFLINE: 'offline',
  ONLINE: 'online',
  BUSY: 'busy'
};

export const USER_TYPES = {
  RIDER: 'rider',
  DRIVER: 'driver',
  ADMIN: 'admin'
};

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyAbQBVRJV0VMP9Q3RJB_bTpYiRhe0NcS90';

export const DEFAULT_LOCATIONS = {
  JOHANNESBURG: { lat: -26.2041, lng: 28.0473 },
  CAPE_TOWN: { lat: -33.9249, lng: 18.4241 },
  DURBAN: { lat: -29.8587, lng: 31.0218 },
  PRETORIA: { lat: -25.7479, lng: 28.2293 }
};

export const SOUTH_AFRICAN_CITIES = [
  'Johannesburg',
  'Cape Town',
  'Durban',
  'Pretoria',
  'Port Elizabeth',
  'Bloemfontein',
  'East London',
  'Kimberley',
  'Polokwane',
  'Nelspruit'
];

export const PAYMENT_METHODS = {
  CASH: 'cash',
  CARD: 'card',
  WALLET: 'wallet',
  INVOICE: 'invoice'
};

export const NOTIFICATION_TYPES = {
  BOOKING_CONFIRMED: 'booking_confirmed',
  DRIVER_ASSIGNED: 'driver_assigned',
  DRIVER_ARRIVED: 'driver_arrived',
  TRIP_STARTED: 'trip_started',
  TRIP_COMPLETED: 'trip_completed',
  PAYMENT_RECEIVED: 'payment_received'
};

export const API_ENDPOINTS = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || window.location.origin
};

export const MAP_STYLES = [
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#ffffff' }]
  }
];

export const FARE_CALCULATION = {
  BASE_FARE: 0,
  PER_KM_RATE: 10.50,
  PER_MINUTE_RATE: 2.00,
  MINIMUM_FARE: 0,
  SURGE_MULTIPLIER: {
    LOW: 1.0,
    MEDIUM: 1.2,
    HIGH: 1.5,
    EXTREME: 2.0
  }
};

export const VEHICLE_TYPES = {
  SEDAN: 'sedan',
  SUV: 'suv',
  HATCHBACK: 'hatchback',
  MINIVAN: 'minivan',
  LUXURY: 'luxury'
};

export const COMMON_LOCATIONS = [
  'OR Tambo International Airport',
  'Sandton City',
  'Cape Town International Airport',
  'V&A Waterfront',
  'Menlyn Park Shopping Centre',
  'Gateway Theatre of Shopping',
  'Nelson Mandela Square',
  'Two Oceans Aquarium',
  'Gold Reef City',
  'uShaka Marine World'
];

export const TIME_FORMATS = {
  SHORT_TIME: 'HH:mm',
  LONG_TIME: 'HH:mm:ss',
  SHORT_DATE: 'DD/MM/YYYY',
  LONG_DATE: 'DD MMMM YYYY',
  DATETIME: 'DD/MM/YYYY HH:mm'
};